import { useMemo } from "react";
import { useAccountProperties } from "../../../api/hooks/useAccountProperties";

type usePropertyParams = {
  accountNumber: number | string;
  propertyId?: number | string;
};
export const useProperty = ({
  accountNumber,
  propertyId,
}: usePropertyParams) => {
  const { data, status, error } = useAccountProperties(accountNumber);

  const property = useMemo(() => {
    const result =
      data &&
      propertyId &&
      data.results.find((property) => property.id === propertyId);

    return result || null;
  }, [propertyId, data]);

  return {
    data: property,
    status,
    error,
  };
};
